import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full h-screen flex items-center justify-center overflow-hidden" data-id="element-71">
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/jvkd653gwYGK9HyqCD93Hp/The_botanical_gallery_Banner.png")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-72">
        <div className="absolute inset-0 bg-forest/40 mix-blend-multiply" data-id="element-73"></div>
        <div className="absolute inset-0 bg-black/20" data-id="element-74"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto flex flex-col items-center" data-id="element-75">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        ease: [0.2, 0.65, 0.3, 0.9]
      }} className="text-5xl md:text-7xl lg:text-8xl text-cream font-bold tracking-wide leading-tight mb-12" data-id="element-76">
          No compres flores.
          <br data-id="element-77" />
          <span className="italic font-normal" data-id="element-78">Regala experiencias.</span>
        </motion.h1>

        <motion.a href="#contacto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="bg-goldBright hover:bg-goldBrightDark text-white font-bold rounded-full px-10 py-4 uppercase tracking-widest text-sm transition-colors duration-300 shadow-md hover:shadow-lg [text-shadow:0_1px_2px_rgba(0,0,0,0.35)]" data-id="element-79">
          Contáctanos
        </motion.a>
      </div>
    </section>;
}